import * as React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@racoon/ui";
import { Namespace, useTypedT } from "@racoon/i18n";

// An approved TTN is read-only: editing it is a deliberate step. Confirming only
// unlocks the form — nothing is written until "Save".
export const TtnEditConfirmModal: React.FC<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}> = ({ open, onOpenChange, onConfirm }) => {
  const t = useTypedT(Namespace.Routes);

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent className="max-w-lg">
        <ModalHeader>
          <ModalTitle className="text-xl font-bold">{t("ttnEditConfirmTitle")}</ModalTitle>
        </ModalHeader>

        <ModalBody className="py-4">
          <p className="text-sm text-text-secondary">{t("ttnEditConfirmDesc")}</p>
        </ModalBody>

        <ModalFooter className="rounded-b-lg border-t border-gray-100 bg-gray-50">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            {t("cancel")}
          </Button>
          <Button variant="opacityBlueWithOutline" onClick={onConfirm}>
            {t("ttnEditConfirm")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
